import { Directive, Injector, Input, OnInit, signal } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { LiteralsService } from '../../services/literals-service';
import { AccountService } from './shared/account.service';
import { SchemaFieldsService } from '../../services/schema-fields.service';
import { SchemaEnum } from '../../interfaces/schema-fields.model';

@Directive()
export abstract class BaseAccountFormComponent implements OnInit {
  @Input() cPaisLoc: string;
  @Input() isEdit: boolean;
  @Input() isCustomer: boolean;
  form!: UntypedFormGroup;
  literals: LiteralsWords;
  schemaFieldsService: SchemaFieldsService;
  maximumFieldLength = signal<{ [key: string]: number }>({});
  requiredField = signal<{ [key: string]: string }>({});

  protected accountService: AccountService;
  protected controlContainer: ControlContainer;
  protected literalsService: LiteralsService;

  constructor(protected injector: Injector) {
    this.accountService = injector.get(AccountService);
    this.controlContainer = injector.get(ControlContainer);
    this.literalsService = injector.get(LiteralsService);
    this.schemaFieldsService = injector.get(SchemaFieldsService);
    this.literals = this.literalsService.getLiteralModule();
  }

  ngOnInit(): void {
    this.onInitForm();
    this.onInitFormFields();
  }

  onInitForm(): void {
    this.form = this.controlContainer.control as UntypedFormGroup;
  }

  async onInitFormFields(): Promise<void> {
    await this.schemaFieldsService.getFieldsSchemas(this.isCustomer ? SchemaEnum.customer : SchemaEnum.prospects, this.getNameOfFields()).then(schemaFields => {
      const maxLength: { [key: string]: number } = {};
      const required: { [key: string]: string } = {};
      schemaFields.forEach(item => {
        const { field, maxlength, required: req } = item;
        maxLength[field] = maxlength;
        required[field] = req.toString();
      });
      this.maximumFieldLength.set(maxLength);
      this.requiredField.set(required);
    });
  }

  abstract getNameOfFields(): string[];
}
